'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hasAgentReplyFromCurrentSession = undefined;

var _both = require('transmute/both');

var _both2 = _interopRequireDefault(_both);

var _messageTypeComparators = require('conversations-schema/pubnub-message/operators/messageTypeComparators');

var _isFromAgent = require('conversations-schema/pubnub-message/operators/isFromAgent');

var _getMessageIsApproximatelyFromCurrentSession = require('conversations-schema/pubnub-message/operators/getMessageIsApproximatelyFromCurrentSession');

var _hasMessages = require('conversations-schema/thread-history/operators/hasMessages');

var _getMessages = require('conversations-schema/thread-history/operators/getMessages');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var hasAgentReplyFromCurrentSession = exports.hasAgentReplyFromCurrentSession = function hasAgentReplyFromCurrentSession(threadHistory) {
  if (!(0, _hasMessages.hasMessages)(threadHistory)) {
    return false;
  }

  var messages = (0, _getMessages.getMessages)(threadHistory);

  var mostRecentAgentReply = messages.findLast((0, _both2.default)(function (message) {
    return !(0, _messageTypeComparators.isInitialMessage)(message);
  }, _isFromAgent.isFromAgent));

  return !!(mostRecentAgentReply && (0, _getMessageIsApproximatelyFromCurrentSession.getMessageIsApproximatelyFromCurrentSession)(mostRecentAgentReply));
};